import { forwardRef } from 'react';

import classNames from 'classnames';

type TInputProps = React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
>;

export const Input = forwardRef<HTMLInputElement, TInputProps>(
    ({ className, disabled, ...props }, ref) => {
        return (
            // eslint-disable-next-line iwoca/input-a11y
            <input
                className={classNames(
                    // Override pandora CSS reset
                    'box-border',
                    'rounded-s border border-solid border-structure-80 px-m py-s font-reg placeholder:font-reg placeholder:text-structure-60 focus:outline-primary-40',
                    className
                )}
                disabled={disabled}
                ref={ref}
                {...props}
            />
        );
    }
);

Input.displayName = 'Input';
